// extracted by mini-css-extract-plugin
export var select = "_qw-0";